<template>
  <app-widget class-widget="xs12">
    <div slot="widget-content">
      <AppFormHeader
        title="Permissões disponíveis"
        icon="security"
      />
      <v-list class="pt-0">
        <v-radio-group
          class="mt-0"
          hide-details
          v-model="selected"
        >
          <v-list-item
            @click="selectRole(item)"
            v-for="(item, i) in regras"
            :key="i"
          >
            <v-list-item-action>
              <v-radio :value="item.id" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-radio-group>
      </v-list>
    </div>
  </app-widget>
</template>

<script>
import AppWidget from '@/components/AppWidget'
import AppFormHeader from '@/components/AppFormHeader'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AppUsuarioRegras',
  components: {
    AppWidget,
    AppFormHeader
  },
  data () {
    return {
      selected: null
    }
  },
  computed: {
    ...mapGetters(['regras', 'usuario']),
    roleSelected () {
      return this.usuario.roles[0]
    }
  },
  methods: {
    ...mapActions(['putUpdateRegraUsuario']),
    async selectRole (item) {
      if (!confirm('Confirme a alteração de regra deste usuário.')) return
      this.selected = item.id
      await this.putUpdateRegraUsuario({ role: this.selected })
      return this.$router.go(0)
    }
  },
  mounted () {
    this.selected = this.roleSelected.id
  }
}
</script>
